import React from 'react';
import Type from 'prop-types';
import { Box, Typography } from '@mui/material';
import cn from 'classnames';
import styles from './AppBarContent.module.css';
import { Skeleton } from '@mui/lab';

const AppBarContent = (props) => {
  const { title: titleProp, subtitle: subtitleProp, loading } = props;

  const renderSkeleton = () => {
    return (
      <>
        <Box my={1}>
          <Skeleton variant="rect" width="90%" height={12} component="div" />
        </Box>
        <Box my={1}>
          <Skeleton variant="rect" width="80%" height={10} component="div" />
        </Box>
      </>
    );
  };

  const renderContent = () => {
    let title = titleProp;
    let subtitle = subtitleProp;

    if (title === null && subtitle === null) {
      return null;
    }

    if (title !== null) {
      title = (
        <Typography
          variant={subtitle !== null ? 'body1' : 'h6'}
          component="span"
          className={styles.title}
          sx={{ fontWeight: 500 }}
        >
          {title}
        </Typography>
      );
    }

    if (subtitle !== null) {
      subtitle = <Typography variant="body2">{subtitle}</Typography>;
    }

    return (
      <>
        {title}
        {subtitle}
      </>
    );
  };

  return (
    <div className={cn('ellipsis', styles.content)}>
      {loading ? renderSkeleton() : renderContent()}
    </div>
  );
};

AppBarContent.propTypes = {
  title: Type.oneOfType([Type.string, Type.node]),
  subtitle: Type.oneOfType([Type.string, Type.node]),
  loading: Type.bool,
};

AppBarContent.defaultProps = {
  title: null,
  subtitle: null,
  loading: false,
};

export default AppBarContent;
